import type { UseQueryOptions } from "@tanstack/react-query";

import type { ResponseError } from "app/services/fetchService";

import type { MethodName, Tag } from "../apiClient";
import { apiClient } from "../apiClient";
import type { Args, Data, IQueryParams } from "../queryTypes";

import { getQueryKey } from "./getQueryKey";

export type QueryOptions<T extends Tag, M extends MethodName<T>, TData = Data<T, M>> = Omit<
    UseQueryOptions<Data<T, M>, ResponseError, TData>,
    "queryKey" | "queryFn"
>;

/**
 * @experimental
 * Builds query options object to be used with TanStack queries.
 */
export const getQueryOptions = <T extends Tag, M extends MethodName<T>, TData = Data<T, M>>(
    { tag, methodName, options = {} }: IQueryParams<T, M, QueryOptions<T, M, TData>>,
    ...args: Args<T, M>
): UseQueryOptions<Data<T, M>, ResponseError, TData> => ({
    ...options,
    queryKey: getQueryKey({ tag, methodName, args }),
    queryFn: () => apiClient[tag][methodName](...args) as Promise<Data<T, M>>,
});
